import { render, staticRenderFns } from "./CalendarioEvaluacionesView.vue?vue&type=template&id=287c87d2&scoped=true"
import script from "./CalendarioEvaluacionesView.vue?vue&type=script&lang=js"
export * from "./CalendarioEvaluacionesView.vue?vue&type=script&lang=js"
import style0 from "./CalendarioEvaluacionesView.vue?vue&type=style&index=0&id=287c87d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c87d2",
  null
  
)

export default component.exports